import { ILicensingInfo } from '../types/ILicensingInfo';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IGetLicensingInfoParams {
}

export interface IGetLicensingInfoResult extends ILicensingInfo {
}

export class GetLicensingInfoRequest extends Request<IGetLicensingInfoParams, IGetLicensingInfoResult> {
  constructor(params: IGetLicensingInfoParams = {}) {
    super('getLicensingInfo', params);
  }
}
